import React from 'react';

// TODO(witems-promote): generic empty-state card; witems ships no Empty/Placeholder primitive today.
// Shared "nothing here yet" placeholder for the patient-file tabs (compact = smaller, in-section variant).
// The title demotes to text-secondary when no description is passed, matching the old single-line notes.
export default function EmptyState({ icon, title, description, action, compact = false }) {
  return (
    <div
      style={{
        background: 'var(--wi-background-secondary)',
        border: '1px dashed var(--wi-divider)',
        borderRadius: 12,
        padding: compact ? '24px 20px' : '40px 32px',
        textAlign: 'center',
      }}
    >
      {!compact && icon && (
        <div
          style={{
            width: 56, height: 56, borderRadius: '50%', background: 'var(--wi-background-primary)',
            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
            marginBottom: 16, color: 'var(--wi-text-secondary)',
          }}
        >
          {icon}
        </div>
      )}
      <p
        className={compact ? 'body2' : 'header4'}
        style={description
          ? { margin: 0, fontWeight: 600, color: 'var(--wi-text-primary)' }
          : { margin: 0, color: 'var(--wi-text-secondary)' }}
      >
        {title}
      </p>
      {description && (
        <p
          className={compact ? 'detail1 text-secondary' : 'body2 text-secondary'}
          style={{ margin: '8px auto 0', maxWidth: 480, lineHeight: 1.6 }}
        >
          {description}
        </p>
      )}
      {action && <div style={{ marginTop: 16 }}>{action}</div>}
    </div>
  );
}
